import { createSlice } from "@reduxjs/toolkit";

const clientSlice = createSlice({
  name: "client",
  initialState: {
    status: "idle",
    error: null,
    loading: false,
    clientLoading: false,
    clientError: null,
    currentClient: null,
    selectedClient: null,
    availableClients: [],
    clientStats: null,
    clientPermissions: null,
    clientUsers: [],
    clientSettings: null,
    clientDashboard: null,
    onboardingStatus: null,
    filters: {
      search: "",
      status: "",
      industry: "",
      location: "",
      sort_by: "created_at",
      sort_order: "desc"
    },
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      totalPages: 0
    }
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
      state.status = "failed";
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setClientLoading: (state, action) => {
      state.clientLoading = action.payload;
    },
    setClientError: (state, action) => {
      state.clientError = action.payload;
    },

    setCurrentClient: (state, action) => {
      console.log("setCurrentClient", action.payload);
      state.currentClient = action.payload;
    },
    clearCurrentClient: (state) => {
      state.currentClient = null;
    },
    setSelectedClient: (state, action) => {
      state.selectedClient = action.payload;
    },
    setAvailableClients: (state, action) => {
      state.availableClients = action.payload;
    },
    addClientToList: (state, action) => {
      state.availableClients.unshift(action.payload);
    },
    updateClientInList: (state, action) => {
      const { clientId, updatedClient } = action.payload;
      state.availableClients = state.availableClients.map(client =>
        client.id === clientId || client.client_id === clientId ? { ...client, ...updatedClient } : client
      );
    },
    removeClientFromList: (state, action) => {
      const clientId = action.payload;
      state.availableClients = state.availableClients.filter(client =>
        client.id !== clientId && client.client_id !== clientId
      );
    },
    setClientStats: (state, action) => {
      state.clientStats = action.payload;
    },
    setClientPermissions: (state, action) => {
      state.clientPermissions = action.payload;
    },
    setClientUsers: (state, action) => {
      state.clientUsers = action.payload;
    },
    setClientSettings: (state, action) => {
      state.clientSettings = action.payload;
    },
    setClientDashboard: (state, action) => {
      state.clientDashboard = action.payload;
    },
    setOnboardingStatus: (state, action) => {
      state.onboardingStatus = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    clearClientState: (state) => {
      state.status = "idle";
      state.error = null;
      state.loading = false;
      state.clientLoading = false;
      state.clientError = null;
      state.currentClient = null;
      state.selectedClient = null;
      state.availableClients = [];
      state.clientStats = null;
      state.clientPermissions = null;
      state.clientUsers = [];
      state.clientSettings = null;
      state.clientDashboard = null;
      state.onboardingStatus = null;
      state.filters = {
        search: "",
        status: "",
        industry: "",
        location: "",
        sort_by: "created_at",
        sort_order: "desc"
      };
      state.pagination = {
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0
      };
    }
  },
});

export const {
  setError,
  setLoading,
  setClientLoading,
  setClientError,
  setCurrentClient,
  clearCurrentClient,
  setSelectedClient,
  setAvailableClients,
  addClientToList,
  updateClientInList,
  removeClientFromList,
  setClientStats,
  setClientPermissions,
  setClientUsers,
  setClientSettings,
  setClientDashboard,
  setOnboardingStatus,
  setFilters,
  setPagination,
  clearClientState
} = clientSlice.actions;

// Selectors
export const selectClientLoading = (state) => state.client.loading;
export const selectClientError = (state) => state.client.error;
export const selectClientList = (state) => state.client.availableClients;
export const selectCurrentClient = (state) => state.client.currentClient;
export const selectSelectedClient = (state) => state.client.selectedClient;
export const selectAvailableClients = (state) => state.client.availableClients;
export const selectClientLoadingState = (state) => state.client.clientLoading;
export const selectClientErrorState = (state) => state.client.clientError;
export const selectClientStats = (state) => state.client.clientStats;
export const selectClientPermissions = (state) => state.client.clientPermissions;
export const selectClientUsers = (state) => state.client.clientUsers;
export const selectClientSettings = (state) => state.client.clientSettings;
export const selectClientDashboard = (state) => state.client.clientDashboard;
export const selectOnboardingStatus = (state) => state.client.onboardingStatus;
export const selectClientFilters = (state) => state.client.filters;
export const selectClientPagination = (state) => state.client.pagination;

export default clientSlice.reducer;
